'use strict';

var React = require('react');

var SvgFraudProtectUnprotectedMajor = function SvgFraudProtectUnprotectedMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.493 2.879c2.264-.317 5.264-1.263 7.635-2.646a1.733 1.733 0 0 1 1.728-.004c2.369 1.354 5.502 2.29 7.65 2.628.818.128 1.491.81 1.491 1.638v.501c.031 6.043-.48 11.332-9.472 14.903a1.45 1.45 0 0 1-1.062 0c-8.985-3.571-9.492-8.86-9.462-14.903l-.001-.497c-.002-.83.672-1.505 1.493-1.62Zm7.8 2.414a1 1 0 0 0-.293.707v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1.707-.707Zm0 8a1 1 0 1 0 1.414 1.414 1 1 0 0 0-1.414-1.414Z"
  }));
};

exports.SvgFraudProtectUnprotectedMajor = SvgFraudProtectUnprotectedMajor;
